import React, { useState, useEffect } from "react";
import { Box, createTheme, Stack, ThemeProvider } from "@mui/material";
import { StocksPage } from "./StocksPage";
import { useParams } from "react-router-dom";
import CompleteStockDetails from "./StocksPageComponents/CompleteStockDetails";
import { Avatar } from "@mui/material";
import ViewQuiltIcon from "@mui/icons-material/ViewQuilt";
import ToggleButton from "@mui/material/ToggleButton";
import logo from "../../images/investchartslogo.png";
import EarningsPage from "./EarningsPage";
import PressReleases from "./PressReleases";

const MainContainer = ({ mode, showSidebar, setShowSidebar, type }) => {
  // const [showSidebar, setShowSidebar] = useState(true);
  const [menu, setMenu] = useState("stocks");
  const params = useParams();
  // useEffect(() => {
  //   if (params?.symbol?.length > 0) {
  //     setMenu("DetailsPage");
  //   } else {
  //     setMenu("stocks");
  //   }
  // }, [params]);
  useEffect(() => {
    if (type == "allStocks") {
      setMenu("stocks");
    }
    if (type == "stockDetails") {
      setMenu("DetailsPage");
    }
    if (type == "earningsCalendar") {
      setMenu("earningsPage");
    }
    if (type == "pressReleases") {
      setMenu("pressReleases");
    }
  }, []);
  useEffect(() => {
    if (type == "allStocks") {
      setMenu("stocks");
    }
    if (type == "stockDetails") {
      setMenu("DetailsPage");
    }
    if (type == "earningsCalendar") {
      setMenu("earningsPage");
    }
    if (type == "pressReleases") {
      setMenu("pressReleases");
    }
  }, [type]);
  return (
    <Box
      sx={{
        backgroundColor: "bgSecondary.main",

        // borderLeft: "1px solid rgb(230, 235, 241)",
      }}
      className="main__container"
    >
      <Box
        sx={{
          backgroundColor: "bgPrimary.main",
          padding: " 10px 20px 10px 20px",
          display: "flex",
          justifyContent: "space-between",
          display: { xs: "flex", md: "none" },
          zIndex: "10000",
        }}
      >
        <img style={{ width: "auto", height: "52px" }} src={logo}></img>
        <ToggleButton
          value="quilt"
          aria-label="quilt"
          onClick={() => setShowSidebar(!showSidebar)}
          sx={{ border: "none" }}
        >
          <ViewQuiltIcon />
        </ToggleButton>
        {/* <Avatar>S</Avatar> */}
      </Box>
      {menu == "stocks" ? (
        <>
          <StocksPage mode={mode} />
        </>
      ) : menu == "DetailsPage" ? (
        <>
          <CompleteStockDetails symbol={params?.symbol} mode={mode} />
        </>
      ) : menu == "earningsPage" ? (
        <>
          <EarningsPage />
        </>
      ) : menu == "pressReleases" ? (
        <>
          <PressReleases />
        </>
      ) : (
        <></>
      )}
    </Box>
  );
};

export default MainContainer;
